import { render, staticRenderFns } from "./ComplaintTypeForm.vue?vue&type=template&id=f5169672&"
import script from "./ComplaintTypeForm.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports